import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'row',

    height: '100dvh',
});
